"use strict";

/* -------------------------------------------------------------------------

	PUNITED.company

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.company) PUNITED.company = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.company;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */
})();

$(function () {
  PUNITED.utils.headLine({
    width: 1971.379,
    height: 161.032,
    d: [{
      command: 'M',
      points: [[-13660.516, -11704.543]]
    }, {
      command: 'c',
      points: [[-110.166, -65.755], [-353.323, -48.359], [-506.558, -9.609]]
    }, {
      command: 's',
      points: [[-123.333, 78.268], [-534.271, 117.438], [-929.781, -98.934], [-929.781, -98.934]]
    }],
    translate: [15631.382, 11749.601]
  }, {
    width: 624.582,
    height: 52.349,
    d: [{
      command: 'M',
      points: [[-15007.312, -11734.646]]
    }, {
      command: 'c',
      points: [[-34.873, -20.815], [-111.848, -15.309], [-160.354, -3.043]]
    }, {
      command: 's',
      points: [[-39.042, 24.777], [-169.128, 37.177], [-294.33, -31.318], [-294.33, -31.318]]
    }],
    translate: [15631.382, 11749.594]
  });
});